import axios from "axios";
import { API_BASE_URL } from "@/service/api-config";
import { normalizeLocale } from "@/lib/utils";

// Helper to get normalized locale (similar to mobile app's context.locale.languageCode)
function getNormalizedLocale(): string {
  if (typeof window === "undefined") return "en";
  
  // 1. Try to get from localStorage first (user preference, like mobile app)
  const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    return normalizeLocale(storedLanguage);
  }
  
  // 2. Try to get from URL path (next-intl format: /en/... or /ar/...)
  // This matches how the website determines locale, similar to mobile app's context.locale
  const pathMatch = window.location.pathname.match(/^\/(en|ar)(\/|$)/);
  if (pathMatch) {
    return normalizeLocale(pathMatch[1]); // Already normalized (en or ar)
  }
  
  // 3. Fallback to navigator.language (browser setting)
  // navigator.language returns format like "en-GB" or "en_US", not the full Accept-Language header
  const browserLanguage = navigator.language || "en";
  return normalizeLocale(browserLanguage);
}

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    // Set default Accept-Language to prevent browser from sending complex header
    "Accept-Language": "en",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    // debugger
    if (typeof window !== "undefined") {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Always override Accept-Language with normalized value
      // This ensures we never send the browser's complex Accept-Language header
      config.headers["Accept-Language"] = getNormalizedLocale();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.message) return response.data.message;
    return response.data;
  },
  (error) => {
    // debugger;
    if (error.response) {
      if (error.response.status === 401) {
        console.log("Unauthorized");
      } else if (error.response.status === 500) {
        console.error("Server Error");
        throw new Error(error.response.data.error.message);
      }
    } else {
      console.error("Network error");
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
